import { render, staticRenderFns } from "./ProductListSib.vue?vue&type=template&id=6889423e&scoped=true"
import script from "./ProductListSib.vue?vue&type=script&lang=js"
export * from "./ProductListSib.vue?vue&type=script&lang=js"
import style0 from "./ProductListSib.vue?vue&type=style&index=0&id=6889423e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_ec1e824a4fe600ca080e24d3f05cd390/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6889423e",
  null
  
)

export default component.exports